import React from 'react'

import InfoPanelLabel from "./info-panel-label"

type Props = {
    icon?           : string
    label?          : string
    isLabelHidden?  : boolean
    contentClass?   : string
    onRemove?       : callback
    className?      : string
    styles?         : any
    labelClassName? : string
    children?       : any
    editable?       : boolean // if true adds .editable class - see css it should hover form elements
}

export default function InfoPanelRow(props:Props) {

    const classes = Classes('ip-section-row', props.className, {
        'editable'      : props.editable
    })

    return (
        <div className={classes} style={props.styles}>

            <div className="first-column">
                {props.onRemove &&
                    <div className="remove-btn i5-minus-circle-solid" onClick={props.onRemove}></div>
                }
            </div>

            {!props.isLabelHidden && (
                <InfoPanelLabel className   = {props.labelClassName}
                                icon        = {props.icon}
                                label       = {props.label}
                                enableHint  = {true} />
            )}

            <div className={Classes("ip-content", props.contentClass, {"w-100-percent": props.isLabelHidden})}>
                {props.children}
            </div>
        </div>
    )
}

